<template>
  <div id="content">
    <div class="page-title">帮助指南
      <div style="height: 8px"></div>
    </div>
    <div divalign="center" style="font-size: 16px">
      <div class="page-title1">小米手机推送相关设置
        <div style="height: 8px"></div>
      </div>
      <p class="page-title2">在叮咚客户端—App设置—开启通知权限里进行设置，以小米11为参考，Android11系统</p>
      <img src="./xm1.png" class="bg"/>
      <p class="page-title2">1.自启动管理去开启</p>
      <img src="./xm2.png" class="bg"/>

      <p class="page-title2">2.通知权限去开启，如下图1，将设置项</p>
      <p class="page-title2">【普通】【重要】【DingDongApp-Channel】【DingDongUpdate-Channel】【系统默认通道】</p>
      <p class="page-title2">1.参照下图2图3，设置相关项。</p>

      <img src="./xm3.png" class="bg"/>
      <p class="page-title2">3.其他权限去开启，跳转之后在页面底部四个设置项开启</p>
      <img src="./xm4.png" class="bg"/>
      <p class="page-title2">4.最后一步，进入手机设置—应用设置—应用管理，找到叮咚-->进入省电策略-->无限制</p>
      <img src="./xm5.png" class="bg"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'no_bind'
  }
</script>

<style scoped>
  .page-title {
    font-size: 18px;
    margin: 20px auto;
    text-align: center;
    display: block;
    line-height: 1;
    left: 118px;
    border-width: 0 0 1px 0;
    font-family:blod  黑体 ;
    font-weight:900;
    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title1 {
    font-family:blod 黑体;
    font-weight:100;

    font-size: 18px;
    margin: 20px auto;
    line-height: 1;
    left: 14px;
    border-width: 0 0 1px 0;

    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title2 {
    left: 14px;
    height: 26px;
    font-family: 简体;
    font-size: 16px;
    color: #666666;
  }

  .bg {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonproblem/nobindmsg/xm/xm.vue